import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Der globale 401-Interceptor haengt ?session=expired an, wenn er einen
  // abgelaufenen Admin-Token verworfen hat. Ohne diesen Hinweis steht man
  // wortlos wieder vor dem Login und haelt es fuer einen Bug. (2026-08-17)
  useEffect(() => {
    if (searchParams.get('session') === 'expired') {
      toast.info('Sitzung abgelaufen — bitte neu anmelden.');
    }
  }, [searchParams]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // First try to setup admin (idempotent, harmless if already exists)
      try { await axios.post(`${BACKEND_URL}/api/auth/setup`); } catch (err) {}

      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);

      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, formData);
      localStorage.setItem('token', response.data.access_token);
      toast.success("Login successful");
      navigate('/admin');
    } catch (error) {
      toast.error("Login failed. Please check credentials.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 border border-gray-200 shadow-xl w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-baseline justify-center">
            <span className="text-3xl font-light tracking-tight">team</span>
            <span className="text-3xl font-black tracking-tight">WERK</span>
          </div>
          <p className="text-gray-500 mt-2">Content Management</p>
        </div>
        
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Benutzername</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-3 border border-gray-300 focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all"
              placeholder="Benutzername"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Passwort</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border border-gray-300 focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all"
              placeholder="••••••••"
            />
          </div>
          <button 
            type="submit" 
            className="w-full bg-black hover:bg-gray-800 text-white h-12 text-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={loading}
          >
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};
